import { render, staticRenderFns } from "./tpProdProductOrder.vue?vue&type=template&id=7127c43c&scoped=true"
import script from "./tpProdProductOrder.vue?vue&type=script&lang=js"
export * from "./tpProdProductOrder.vue?vue&type=script&lang=js"
import style0 from "./tpProdProductOrder.vue?vue&type=style&index=0&id=7127c43c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7127c43c",
  null
  
)

export default component.exports